import { getCallable } from "../../../_sdk/client";
import { apiName, endpoints } from "./endpoints";
import type {
    GetWorkspacePlanDataRequest,
    GetWorkspacePlanDataResponse,
    GetAvailableTrialDaysRequest,
    GetAvailableTrialDaysResponse,
    UpgradeWorkspacePlanRequest,
    UpgradeWorkspacePlanResponse,
    FinalizeUpgradeWorkspacePlanRequest,
    FinalizeUpgradeWorkspacePlanResponse,
    AbortUpgradeWorkspacePlanRequest,
    AbortUpgradeWorkspacePlanResponse
} from "./types";

export { apiName };

const getWorkspacePlanData = getCallable<GetWorkspacePlanDataRequest, GetWorkspacePlanDataResponse>(
    apiName,
    "getWorkspacePlanData",
    {
        ...endpoints.getWorkspaceBillingData,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/billing/plan`,
                options: {
                    method: "GET"
                }
            };
        }
    });

const upgradeWorkspacePlan = getCallable<UpgradeWorkspacePlanRequest, UpgradeWorkspacePlanResponse>(
    apiName,
    "upgradeWorkspacePlan",
    {
        ...endpoints.upgradeWorkspacePlan,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/billing/upgrade`,
                options: {
                    method: "POST",
                    body: JSON.stringify(request)
                }
            };
        }
    });

const finalizeUpgradeWorkspacePlan = getCallable<FinalizeUpgradeWorkspacePlanRequest, FinalizeUpgradeWorkspacePlanResponse>(
    apiName,
    "finalizeUpgradeWorkspacePlan",
    {
        ...endpoints.finalizeUpgradeWorkspacePlan,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/billing/upgrade/finalize`,
                options: {
                    method: "POST",
                    body: JSON.stringify(request)
                }
            };
        }
    });

const abortUpgradeWorkspacePlan = getCallable<AbortUpgradeWorkspacePlanRequest, AbortUpgradeWorkspacePlanResponse>(
    apiName,
    "abortUpgradeWorkspacePlan",
    {
        ...endpoints.abortUpgradeWorkspacePlan,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/billing/upgrade/abort`,
                options: { method: "POST" }
            };
        }
    });

const getAvailableTrialDays = getCallable<GetAvailableTrialDaysRequest, GetAvailableTrialDaysResponse>(
    apiName,
    "getAvailableTrialDays",
    {
        ...endpoints.getAvailableTrialDays,
        composer: request => {
            return {
                url: `/workspaces/any/billing/trial-days`,
                options: { method: "GET" }
            };
        }
    }
);

export const callables = {
    getWorkspacePlanData,
    upgradeWorkspacePlan,
    finalizeUpgradeWorkspacePlan,
    abortUpgradeWorkspacePlan,
    getAvailableTrialDays
};
